import { useEffect, useMemo, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";

import { emptyOption } from "../../constants";
import { grupoEtapasService } from "../../_services/grupoEtapas.service";
import { setLoading } from "../../redux/Loading/actions";
import { tipoEtapasService } from "../../_services/tipoEtapas.service";
import Select from "../Select";
// import { useUser } from "../../hooks/useUser";
import { showTable } from "../../redux/Sections/Inmuebles/actions";
import "./Filter.css";

export const Filter = ({ action, setData, reference, showFilter, fields, setFilters, setShowFilter, setShowTable }) => {
  const dispatch = useDispatch();
  // const user = useUser();

  const [grupos, setGrupos] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [grupo, setGrupo] = useState("");

  const {
    register,
    handleSubmit,
    control,
    reset
  } = useForm({});

  const [tags, setTags] = useState({});

  useEffect(() => {
    const getData = async () => {
      let response = await grupoEtapasService.getGrupoEtapas();

      if (response?.length) {
        setGrupos(response.map(e => {
          return {
            ...e,
            value: e.id,
            label: e.nombre
          };
        }));
      }

    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      if (grupo && grupo.id) {
        dispatch(setLoading(true));

        let response = await tipoEtapasService.getTipoEtapas(grupo.id);

        if (response?.length) {
          setTipos(response.map(e => {
            return {
              ...e,
              value: e.tipo,
              label: e.nombre
            };
          }));

          dispatch(setLoading(false));
        }
        else {
          dispatch(setLoading(false));
        }
      }
      else {
        setTipos([]);
      }
    };

    getData();
  }, [grupo]);

  const handleClean = () => {
    reset({});
    setTags({});
    setGrupo({});
  };

  const onSubmit = async (data) => {
    setTags(data);
    if(setFilters){
      setFilters(data);
    }

    // if ("A00" !== user?.abogado) {
    //   data.usuario = user.dni;
    // }

    const res = await action(data);

    setData(res);

    setShowFilter(false);
    if (setShowTable) {
      setShowTable(true);
    }
    dispatch(showTable());
  };

  const handleChange = (e) => {
    if (e) {
      setGrupo(e);
    }
    else {
      setGrupo("");
    }
  };

  const defaultFields = useMemo(
    () => [
      [
        {
          label: "Contribuyente",
          type: "text",
          name: "contribuyente",
        },
        {
          label: "N° imponible",
          type: "text",
          name: "nro_imponible",
        },
        {
          label: "Recurso",
          type: "text",
          name: "recurso",
        },
        {
          label: "DNI",
          type: "text",
          name: "dni",
        },
      ],
      [
        {
          label: "CUIM",
          type: "cuim",
          name: "contribuyente",
        },
        {
          label: "Barrio",
          type: "text",
          name: "barrio",
        },
        {
          label: "Calle",
          type: "text",
          name: "calle",
        },
        {
          label: "Altura",
          type: "text",
          name: "altura",
        },
      ],
      [
        {
          label: "Estados",
          type: "select",
          name: "estado",
          options: grupos?.length ? [emptyOption, ...grupos] : [emptyOption],

        },
        {
          label: "Estado de causa",
          type: "select",
          name: "estado_causa",
          options: tipos?.length ? [emptyOption, ...tipos] : [emptyOption],

        },
        {
          label: "Ultima fecha de movimiento",
          type: "date",
          name: "fecha_movimiento",
        },
        {
          label: "Ultima fecha de ingreso",
          type: "date",
          name: "fecha_ingreso",
        },
      ]
    ],
    [grupos, tipos]
  );

  return (
    <div className="filter-container" >
      {showFilter ? (
        <Form onSubmit={handleSubmit(onSubmit)} >
          {(fields || defaultFields).map((row, i) => {
            return (
              <Row key={`field-${i}`} className="mb-2">
                {row.map((e) => {
                  if (e.type === "select") {
                    return (
                      <Col sm={12} md={3} className="mt-3" key={e.name}>
                        <Form.Label className="mb-2">{e.label}</Form.Label>
                        <Controller
                          name={e.name}
                          control={control}
                          render={({ field: { value, onChange } }) => {
                            let findValue = e.options.find(o => o.value === value);
                            return (
                              <Select
                                options={e.options}
                                value={findValue}
                                onChange={(e) => {
                                  handleChange(e);
                                  return onChange(e?.value);
                                }}
                              />
                            );
                          }}
                        />
                      </Col>
                    );
                  }
                  else {
                    return (
                      <Col sm={12} md={3} className="mt-3" key={e.name}>
                        <Form.Label className="mb-2">{e.label}</Form.Label>
                        <Form.Control
                          type={e.type}
                          name={e.name}
                          placeholder={e.label}
                          {...register(e.name)}
                        />
                      </Col>
                    );
                  }
                })}
              </Row>
            );
          })}

          <Row className=" d-flex justify-content-end mt-3" >
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="button"
                variant="danger"
                onClick={handleClean}
                className="danger-button d-flex align-items-center"
              >
                <FontAwesomeIcon icon={faEraser} size="1x" /><span className="ml-2">LIMPIAR</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="submit"
                ref={reference}
                className="custom-button"
              >
                BUSCAR
              </Button>
            </Col>
          </Row>
        </Form>
      ) : null}
      <>
        {
          <Row className="d-flex justify-content-start mt-4" style={{ paddingLeft: 15 }}>
            <div className="filterby">
              <h5 style={{ marginTop: "2px", fontWeight: 700 }} >Filtrado por:</h5>
            </div>
            {!Object.values(tags).filter((e) => e !== "").length && (
              <div className="tags">
                <span
                  key="sinopciones"
                >
                  No hay opciones seleccionadas
                </span>
              </div>
            )}

            {tags?.apynom &&
              <div className="tags">
                <span key="apynom" >
                  Nombre : {tags.apynom}
                </span>
              </div>}

            {(fields || defaultFields)?.flat().map((e, i) => {
              return tags[e.name] &&
                <div className="tags" key={i}>
                  <span >
                    {e.label} : {tags[e.name]}
                  </span>
                </div>;
            })}
          </Row>
        }
      </>
    </div>
  );
};
